import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getCurrentInstance as n } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function r() {
  return n() !== null;
}
const o = typeof window != "undefined";
export {
  r as hasInstance,
  o as isBrowser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/utils.js
// module id = 339
// module chunks = 67